import { createSelector, createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
    name: "users",
    initialState: {
        list: [],
        userProfile: [
            {
                username: 'Charles Xavier',
                email: 'chharlie4@example.com',
                phone: '989767231',
                status: 'Active',
                memberSince: 'January 1, 2020',
                imageUrl: 'https://via.placeholder.com/150',
            }
        ],
        otpMode: "Email",
        loading: false,
        lastFetch: null,
        addedStatus: false,
        assignedUserlist: []
    },
    reducers: {
        userAdded: (users, action) => {
            users.addedStatus = action.payload;
        },
        otpModeAdded: (users, action) => {
            users.otpMode = action.payload;
        },
        updateUser: (users, action) => {
            users.userProfile = action.payload;
        },
        usersReceived: (users, action) => {
            users.addedStatus = false;
            users.list = action.payload;
        },
        assignedUsersReceived: (users, action) => {
            users.assignedUserlist = action.payload;
        }
    }
});

const allUsers = "user/allUsers";
const addUser = "user/addUser";
const assignedUsers = "user/GetAssignedPerformers";

export const { userAdded, usersReceived, updateUser, assignedUsersReceived,otpModeAdded } = slice.actions;
export default slice.reducer;


export const loadAllUsers = (pageSize, pageIndex) => apiCallBegan({
    url: allUsers + "?pageSize=" + pageSize + "&pageIndex=" + pageIndex,
    onSuccess: usersReceived.type
});

export const loadAssignedUsers = (ids) =>
  apiCallBegan({
    url: assignedUsers + "?" + ids,
    onSuccess: assignedUsersReceived.type,
  });

export const addNewUser = data => apiCallBegan({
    url: addUser,
    method: "post",
    data: data,
    onSuccess: userAdded.type,
});

export const updateUserDetails = data => apiCallBegan({
    // url: addUser,
    // method: "post",
    // data: data,
    // onSuccess: updateUser.type,
});

export const getAllUsers = createSelector(
    state => state.entities.users,
    users => users.list
)
export const getUserAddedStatus = createSelector(
    state => state.entities.users,
    users => users.addedStatus
)
export const getProfileUser = createSelector(
    state => state.entities.users,
    users => users.userProfile
)
export const getOtpMode = createSelector(
    state => state.entities.users,
    users => users.otpMode
)

export const getAssignedUserlist = createSelector(
    state => state.entities.users,
    users => users.assignedUserlist
)